
export const LeaseDirectorDashboardPermissions = {
    AccountsDashboard: {
    permissionsId:'8b9a59c2-e73e-4c79-1cd4-08dabfc53c80',
    permissionsName:'Lease Director Dashboard',
    componentsId:null,
    components:null
  }
  } ;
  